import React, { useEffect, useState } from 'react';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';

const Device = ({ _id }) => {
  const [device, setDevice] = useState({});

  useEffect(() => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/gere/device/' + _id, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setDevice(data));
  }, [_id]);

  return <div>{device.no} <PhoneAndroidIcon /></div>;
};

export default Device;



// WEBPACK FOOTER //
// src/components/devices/Device.js